import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";
import CustomButton from "components/Button";

const ConfirmationDialog = ({ open, onClose, onConfirm, title, message }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ fontWeight: "bold" }}>{title}</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2">{message}</Typography>
      </DialogContent>
      <DialogActions>
        <CustomButton title="Cancel" variant="outlined" onClick={onClose} />
        <CustomButton title="Confirm" variant="filled" onClick={onConfirm} />
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;